<template>
  <div class="wrapper">
    <div class="header">
      <!--返回|退出按钮-->
      <div class="go-back" @click="goBack" />
      <!--规则按钮-->
      <div class="rule" @click="ruleShow = !ruleShow">规则</div>
    </div>
    <div class="dial">
       <!--转盘图片标题-->
      <div class="title" />
      <!--转盘旋转光效-->
      <div class="light">
        <img src="~@/assets/images/spin_win/light.png" />
      </div>
      <div class="dial-box">
        <!--转盘图片-->
        <div class="dish">
          <img 
          src="~@/assets/images/spin_win/dish.png"
          :style="{transform:rotate_deg,transition:rotate_transition}" />
        </div>
        <!--转盘白色光照蒙层-->
        <div class="dish-meng">
          <img src="~@/assets/images/spin_win/dish_meng.png" />
        </div>
        <!--转盘指针-->
        <div class="pointer" @click="start()">
          <img src="~@/assets/images/spin_win/pointer.png" />
        </div>
        <!--转盘跑马灯圆点-->
        <div
          :class="'dish-circle dish-circle-'+index"
          v-for="(item,index) in dishCircleList"
          :key="index"
          :style="{background:index%2==0?colorCircleFirst:colorCircleSecond}"
        />
        <!--转盘剩余抽奖次数-->
        <div class="residue">剩余{{totalNum - clickNum}}次</div>
      </div>
      <!--额外红包-->
      <div class="redpack-box">
        <div class="redpack-content">
          <span class="r-title">- 额外奖励 -</span>
          <!--额外红包列表-->
          <div class="r-list">
            <div
              class="r-item"
              v-for="(item,index) in rlist"
              :key="index"
              @click="receiveRepack(item)">
              <span :class="parseInt(item.status) == 2 ? 'anim' : ''">{{item.money_txt}}元<br>最高</span>
              <span :class="parseInt(item.status) == 3 ? 'selected' : ''">抽{{item.txt}}次</span>
            </div>
          </div>
          <!--额外红包进度-->
          <div class="r-progress">
            <span :style="{left: progressCircle}"/>
            <span :style="{width: progressLine}"/>
          </div>
        </div>
      </div>
    </div>

    <!--规则弹窗-->
    <van-popup v-model="ruleShow" :close-on-click-overlay=false>
      <div class="introduce">
        <div class="title"/>
        <div class="close" @click="ruleShow = false"/>
        <div class="rule_info">
          <div v-html="ruleTxt"/>
        </div>
      </div>
    </van-popup>

    <!--红包弹窗-->
    <van-popup v-model="redpackShow" class="redpack-popup-wrapper" :close-on-click-overlay=false>
      <div class="redpack-popup">
        <div class="redpack-popup-close" @click="closeRedpack()"/>
        <div class="redpack-popup-light">
          <img src="~@/assets/images/spin_win/rlight.png" />
        </div>
        <div class="redpack-popup-content" @click="clickRedpack()">
          <div>恭喜您获得红包</div>
          <div>
            <span>20</span>
            <span>最高</span>
            <span>元</span>
          </div>
        </div>
      </div>
    </van-popup>

    <!--奖励弹窗-->
    <van-popup v-model="rewardShow" :close-on-click-overlay=false>
      <div class="reward-popup">
        <div class="reward-light">
          <img src="~@/assets/images/spin_win/reward_light.png" />
        </div>
        <div class="reward-popup-content">
            <div :class="isDouble === false ? '' : 'double-class'"/>
            <div v-if="isDouble === false"/>
            <div v-else class="double-txt">翻倍奖励</div>
            <div>
              <span>+</span>
              <span>{{rewardCoin}}</span>
              <span>金币</span>
              <span>=￥{{parseFloat(rewardCoin/10000).toFixed(4)}}</span>
            </div>
            <div v-if="isDouble === false">金币可提现</div>
            <div v-else>可去个人中心查看金币</div>
            <div v-if="isDouble === false" @click="doubleReceive()">
              <span><img src="~@/assets/images/spin_win/play.png" /></span>
              <span>翻5倍领取</span>
              <span/>
            </div>
            <div v-else @click="resetVal()">
              <span/>
              <span>开心收下</span>
            </div>
            <div v-if="isDouble === false" @click="resetVal()">放弃领取多倍奖励</div>
        </div>
      </div>
    </van-popup>

    <!--加载中-->
    <loading :isLoad="isLoad" />
  </div>
</template>

<script>
import Vue from "vue";
import { Popup, Toast } from "vant";
Vue.use(Popup).use(Toast);
import Loading from "@/components/Loading";
let light_timer; //圆点跑马灯定时器
export default {
  name: "SpinWin",
  data() {
    return {
      dishCircleList: [], //圆点设置
      colorCircleFirst: "#fee377", //圆点颜色1
      colorCircleSecond: "#ffffff", //圆点颜色2
      isLoad: false, // 加载中
      ruleShow: false, // 规则弹窗
      redpackShow: false, // 红包弹窗
      rewardShow: false, // 奖励弹窗
      totalNum: 0, // 今日可抽奖总次数
      clickNum: 0, // 今日使用了抽奖次数
      ruleTxt:"参与本活动前，请仔细阅读本活动规则及相关条款。凡参与本活动，则视用户已阅读理解并同意本活动规则（包括活动参与条件、活动参与方式、奖品及注意事项等）全部内容。<br><br>【活动参与方式】<br>1）用户参与本活动转盘抽奖，有机会获得金币、金币红包、惊喜礼包等，具体金额数以系统随机发放为准。用户抽中红包后均需看完创意视频方可取相应红包；<br>2）用户每天有50次抽奖机会，次日抽奖次数清零并重置，每日抽奖达到5次、10次、15次可以获得额外的红包奖励；<br><br>【注意事项】<br>凡以不正当手段（包括但不限于扰乱系统、实施网络攻击使用网络外挂等）参与活动的用户，以及其他作弊违规行为不正当获得活动权益的，用户在参与活动过程中违反国家法律或侵犯他人合法权益包括利用活动辱骂骚扰他人，上传违法违规内容，违反社会公序良俗，侵犯他人合法权益的，本公司有权取消用户活动参与资格，并有权回收用户获得的权益，如有问题请联系客服。",
      rlist: [], // 额外红包列表
      cat: 45, //总共8个扇形区域，每个区域约45度
      isAllowClick: true, // 是否允许点击抽奖
      rotate_deg: 0, // 转盘旋转的角度
      rotate_transition: "transform 3s ease-in-out", //转盘旋转动画及时间
      progressCircle: 0, //额外红包圆点进度
      progressLine: 0, //额外红包进度条进度
      code: "", // 领取奖励code
      type: 1, // 奖励类型 1 金币奖励 2 红包奖励 3 附加红包
      tipsConfigTxt: "", // 激励视频浮窗提示文案
      rewardCoin: 0, // 奖励金币
      isDouble: false,
      doubleCode: "" // 翻倍奖励code
    };
  },
  components: {
    Loading
  },
  created() {
    this.showcircleList();
    this.userid = this.getCookie("userid");
    this.deviceid = this.getCookie("device_id");
    this.appVersion = this.getCookie("app_version");
    if (this.$route.query.debug == 1) {
      this.userid = this.$route.query.userid;
      this.deviceid = this.$route.query.device_id;
      this.appVersion = this.$route.query.app_version;
    }
    // 获取转盘数据
    this.getData();
  },
  mounted() {
    // 播放广告回调
    window.playH5AdResult = (res) => {
      console.log(res, "广告数据回调");
      // 播放广告完成
      if (parseInt(res) == 1) {
        this.complete(this.type); // 广告播放成功 发放奖励
      } else {
        this.toast("奖励领取失败:播放广告失败");
      }
    };
  },
  methods: {
    // 获取cookie值
    getCookie(name) {
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    // 调用客户端方法
    callClienFunc(fname, fval) {
      console.log(fname, fval, 111);
      if (window.hasOwnProperty("injectedObject")) {
        window.injectedObject.setJsContent(fname, JSON.stringify(fval));
      } else {
        fval = fval ? fval : {};
        let params = { method: fname, params: fval };
        params = JSON.stringify(params);
        window.Android.postMessage(params);
      }
    },
    // 关闭页面
    goBack() {
      this.callClienFunc("closeWebview", "");
    },
    //绘制跑马灯圆点
    showcircleList() {
      let dishCircleList = [];
      for (var i = 0; i < 10; i++) {
        dishCircleList.push(i);
      }
      this.dishCircleList = dishCircleList;
      this.light();
    },
    //跑马灯闪动效果
    light() {
      var that = this;
      clearInterval(light_timer);
      light_timer = setInterval(function() {
        if (that.colorCircleFirst == "#fee377") {
          that.colorCircleFirst = "#ffffff";
          that.colorCircleSecond = "#fee377";
        } else {
          that.colorCircleFirst = "#fee377";
          that.colorCircleSecond = "#ffffff";
        }
      }, 300);
    },
    // 计算额外红包进度条长度
    calcProgressWidth() {
      let temp = 0;
      if (this.clickNum <= 5) {
        temp = (13 / 5) * this.clickNum;
      } else if (this.clickNum > 5 && this.clickNum <= 10) {
        temp = 13 + (35 / 5) * (this.clickNum - 5);
      } else if (this.clickNum > 10 && this.clickNum <= 15) {
        temp = 48 + (35 / 5) * (this.clickNum - 10);
      } else if (this.clickNum > 15) {
        temp = 83 + (17 / 35) * (this.clickNum - 15);
      }
      this.progressCircle = temp + "%";
      this.progressLine = temp + 1 + "%";
    },
    // 重置初始值
    resetVal() {
      this.rewardShow = false;
      this.rewardCoin = 0;
      this.code = "";
      this.doubleCode = "";
      this.type = 1;
      this.isDouble = false;
      this.getData();
    },
    // 自定义toast 样式自定义
    toast(message) {
      Toast({ message: message, className: "toast-spin-win" });
    },
    // 开始抽奖
    start() {
      if (this.totalNum - this.clickNum <= 0) {
        this.toast("今日抽奖次数已用完,请明日再来");
        return;
      }
      this.rotating(); // 开始转盘抽奖
    },
    // 计算奖励
    rotating() {
      // 处理并发 当前抽奖完成后才允许下一次点击
      if (!this.isAllowClick) return;
      this.isAllowClick = false;
      this.rotate_transition = "transform 3s ease-in-out";
      this.clickNum++; // 今日使用次数自增
      let rand_circle = 5; //默认多旋转5圈

      // 金币 红包 礼包对应的索引值数组 礼包不可抽中
      let coinIndex = [1, 3, 5, 7];
      let rIndex = [0, 4];

      // 根据奖励类型 获取转盘需要旋转到的下标
      let type = parseInt(this.type);
      let winningIndex = -1;
      switch (type) {
        case 1:
          winningIndex =
            coinIndex[Math.floor(Math.random() * coinIndex.length + 1) - 1];
          break;
        case 2:
          winningIndex =
            rIndex[Math.floor(Math.random() * rIndex.length + 1) - 1];
          break;
        case 3:
          break;
        default:
          break;
      }

      if (winningIndex < 0) {
        this.toast("奖励领取失败:参数错误, 请重试");
        this.getData(); // 重新刷新转盘数据
        this.isAllowClick = true;
        return;
      }

      // 计算需要旋转的角度
      var randomDeg = 360 - winningIndex * this.cat; //当前下标对应的角度  cat = 45是总共8个扇形区域，每个区域约45度 由于是顺时针的转动方向需要用360度来减
      var deg = rand_circle * 360 + randomDeg; // 将要旋转的度数
      this.rotate_deg = "rotate(" + deg + "deg)";
      console.log(winningIndex);
      console.log(this.rotate_deg);

      // 执行旋转完成耗时3s 所以3.5秒后结算奖励
      var that = this;
      setTimeout(function() {
        that.isAllowClick = true;
        //定时器关闭的时候重置角度(这里到奖励的最低角度)
        that.rotate_deg = "rotate(" + (360 - winningIndex * that.cat) + "deg)";
        that.rotate_transition = "";
        that.receiveDial();
      }, 3500);
    },
    // 领取转盘奖励
    receiveDial() {
      let type = parseInt(this.type);
      if (type == 1) {
        console.log("开始播放全屏插屏广告");
        this.showAds();
        // 在广告回调方法
        // this.complete(this.type);
        // this.rewardShow = true; // 金币奖励 直接显示全屏插屏 看完后弹出奖励弹窗
      } else {
        console.log("开始弹出转盘红包奖励弹窗");
        this.redpackShow = true; // 红包奖励 显示红包弹窗 点击红包弹窗 显示激励视频 看完后弹出奖励弹窗
      }
    },
    // 展示广告
    showAds() {
      let adType = "4"; // 默认激励视频
      if (this.isDouble == true) {
        adType = "4"; // 翻倍奖励播放激励视频
      } else if (this.type == 2) {
        adType = "4"; // 红包奖励播放激励视频
      } else if (this.type == 1) {
        adType = "2";
      } else {
        adType = "4";
      }
      // console.log(adType)
      // this.complete(this.type); // 广告播放成功 发放奖励
      let params = {
        adType: adType, // 2 插屏 4 激励视频
        adCode: "", // 广告代码位
        tips: adType == "4" ? this.tipsConfigTxt : "" // 激励视频浮窗文案
      };
      this.callClienFunc("playH5Ad", params);
    },
    // 翻倍领取
    doubleReceive() {
      this.isDouble = true;
      this.rewardShow = false;
      console.log("开始播放翻倍激励视频");
      this.showAds();
      //this.complete(this.type);
    },
    // 关闭红包弹窗(仅限点击关闭按钮 不领取奖励的情况) 刷新转盘
    closeRedpack() {
      console.log("关闭红包奖励弹窗");
      this.redpackShow = false;
      this.getData(); // 重新刷新转盘数据
    },
    // 领取额外红包
    receiveRepack(item) {
      let num = parseInt(item.txt);
      let status = parseInt(item.status);
      this.type = parseInt(item.type);
      this.code = item.code ? item.code : "";
      if (this.clickNum < num) {
        this.toast("还未达到兑换条件，请加油！");
        return false;
      }
      switch (status) {
        case 1:
          this.toast("还未达到兑换条件，请加油！");
          break;
        case 2:
          // 达到领取条件  领取附加任务红包
          console.log("开始弹出额外红包奖励弹窗");
          this.redpackShow = true;
          //this.showAds()
          break;
        case 3:
          this.toast("该红包已经领取, 请明日再来");
          break;
      }
    },
    // 单击红包弹窗开启红包 弹出激励视频
    clickRedpack() {
      this.redpackShow = false;
      console.log("开始播放激励视频");
      this.showAds();
    },
    // 完成领取奖励
    complete(type) {
      console.log("开始调用接口发放奖励");
      this.redpackShow = false; // 隐藏红包弹窗
      let params = {
        app_version: this.appVersion,
        userid: this.userid,
        device_id: this.deviceid,
        code: this.isDouble === true ? this.doubleCode : this.code,
        type: type
      };
      // http://gametest.lushihudong.com/api/user_web/turntable_receive
      //this.isLoad = true;
      this.$http
        .get("/api/user_web/turntable_receive", {
          params: params
        })
        .then(res => {
          //this.isLoad = false;
          if (res.code == 1) {
            this.rewardCoin = res.data.coin; // 奖励金额
            // 是否是翻倍奖励
            if (this.isDouble === false) {
              this.doubleCode = res.data.code;
            }
            // 显示奖励弹窗
            this.rewardShow = true;
            this.calcProgressWidth(); //计算进度条长度
          } else {
            this.toast("奖励领取失败:" + res.message);
            this.getData();
          }
        });
    },
    // 获取转盘首页数据
    getData() {
      let params = {
        app_version: this.appVersion,
        userid: this.userid,
        device_id: this.deviceid
      };

      // http://gametest.lushihudong.com/api/user_web/turntable_index
      this.isLoad = true;
      this.$http
        .get("/api/user_web/turntable_index", {
          params: params
        })
        .then(res => {
          if (res.code == 1) {
            this.totalNum = res.data.total_num ? res.data.total_num : 0;
            this.clickNum = res.data.luck_draw_num ? res.data.luck_draw_num : 0;
            this.code = res.data.code ? res.data.code : "";
            this.type = res.data.type ? parseInt(res.data.type) : 1;
            if (res.data.explain_txt) {
              this.ruleTxt = res.data.explain_txt;
            }
            this.tipsConfigTxt = res.data.tips_config.video_txt
              ? res.data.tips_config.video_txt
              : "";
            this.rlist = res.data.additional_reward;
            this.calcProgressWidth(); //计算进度条长度
          } else {
            this.toast("查询失败:" + res.message); //弹出错误信息
          }
          this.isLoad = false;
        });
    }
  }
};
</script>


<style lang="less" scoped>
.wrapper {
  font-family:PingFang-SC-Regular,Helvetica Neue,Helvetica,microsoft yahei,sans-serif;
  position: relative;
  display: block;
  width: 100%;
  max-width: 3.75rem;
  min-height: 100vh;
  background-image: linear-gradient(
    180deg,
    #ff3c47 0%,
    #fcaf71 24%,
    #fcbf77 56%,
    #ff493f 100%
  );
  overflow: hidden;

  /** 顶部 */
  .header {
    position: absolute;
    display: flex;
    top: 0.38rem;
    width: calc(100% - 0.32rem);
    height: 0.22rem;
    padding: 0 0.16rem;
    justify-content: space-between;
    align-items: center;
    z-index: 72;

    /** 返回|退出按钮 */
    .go-back {
      display: block;
      width: 0.09rem;
      height: 0.16rem;
      background: url("~@/assets/images/high_reward/back.png") no-repeat;
      background-size: 0.09rem 0.16rem;
    }
    /** 规则 */
    .rule {
      display: block;
      font-size: 0.16rem;
      color: #ffffff;
      text-align: right;
    }
  }

  /** 头部 */
  .dial {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    background: url("~@/assets/images/spin_win/bg.png") no-repeat;
    background-size: 3.75rem 5.7rem;
    position: relative;
    overflow: hidden;
    .title {
      display: block;
      width: 2.4rem;
      height: 0.9rem;
      background: url("~@/assets/images/spin_win/title.png") no-repeat;
      background-size: 2.4rem 0.9rem;
      margin: 0 auto;
      margin: 0.66rem 0 0.12rem 0;
    }
    .light {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 1.51rem;
      z-index: 70;
      img {
        width: 3.75rem;
        height: 3.75rem;
        animation: turn 2s linear infinite;
      }
    }
    .dial-box {
      position: relative;
      display: flex;
      justify-content: center;
      width: 3.5rem;
      min-height: 4.6rem;
      background: url("~@/assets/images/spin_win/dial_bg.png") no-repeat;
      background-size: 3.5rem 4.5rem;
      z-index: 71;

      .dish {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.41rem;
        img {
          width: 2.62rem;
          height: 2.62rem;
        }
      }
      .dish-meng {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.41rem;
        img {
          width: 2.62rem;
          height: 2.62rem;
        }
      }
      .pointer {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
        margin-left: 0.03rem;
        img {
          width: 0.9rem;
          height: 1.2rem;
        }
      }
      .residue {
        position: absolute;
        bottom: 0.84rem;
        font-size: 0.16rem;
        color: #ffffff;
        text-align: center;
        font-weight: 500;
        text-shadow: 0 0.02rem 0.03rem rgba(255, 4, 0, 0.44);
      }
      /* 圆点 */
      .dish-circle {
        position: absolute;
        display: block;
        border-radius: 0.16rem;
        height: 0.135rem;
        width: 0.135rem;
        background: white;
        top: 0.07rem;
      }
      .dish-circle-0 {
        right: 1.69rem;
      }

      .dish-circle-1 {
        top: 0.355rem;
        right: 0.767rem;
      }

      .dish-circle-2 {
        top: 1.12rem;
        right: 0.184rem;
      }

      .dish-circle-3 {
        top: 2.085rem;
        right: 0.17rem;
      }

      .dish-circle-4 {
        top: 2.88rem;
        right: 0.74rem;
      }

      .dish-circle-5 {
        top: 3.19rem;
        right: 1.68rem;
      }

      .dish-circle-6 {
        top: 2.89rem;
        left: 0.735rem;
      }

      .dish-circle-7 {
        top: 2.095rem;
        left: 0.155rem;
      }

      .dish-circle-8 {
        top: 1.13rem;
        left: 0.168rem;
      }

      .dish-circle-9 {
        top: 0.36rem;
        left: 0.745rem;
      }
    }

    .redpack-box {
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(90deg, #fff1e0 27%, #fff278 82%);
      width: calc(100% - 0.48rem);
      height: 1.78rem;
      margin-bottom: 0.24rem;
      border-radius: 0.1rem;
      margin-top: -0.75rem;
      z-index: 72;
      .redpack-content {
        position: relative;
        display: flex;
        align-items: center;
        flex-flow: column;
        background-image: linear-gradient(180deg, #ffeab0 27%, #fec579 82%);
        width: calc(100% - 0.2rem);
        height: 1.58rem;
        border-radius: 0.09rem;
        padding: 0.08rem;
        span.r-title {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 0.4rem;
          background: rgba(241, 183, 106, 0.18);
          border-radius: 0.1rem;
          font-size: 0.16rem;
          color: #b95c26;
        }
        .r-list {
          display: flex;
          justify-content: space-around;
          width: 100%;
          padding: 0.12rem 0 0.08rem 0;
          .r-item {
            display: flex;
            flex-flow: column;
            align-items: center;
            position: relative;
            span:first-child {
              display: flex;
              justify-content: center;
              text-align: center;
              align-items: flex-end;
              padding-bottom: 0.06rem;
              width: 0.5rem;
              height: 0.56rem;
              font-size: 0.11rem;
              color: #fffeda;
              background: url("~@/assets/images/spin_win/rbg.png") no-repeat;
              background-size: 0.5rem 0.62rem;
              line-height: 0.12rem;
              margin-bottom: 0.24rem;
            }
            span:nth-child(2) {
              font-size: 0.14rem;
              color: #9a3800;
            }
            span.anim {
              animation: jump 1s infinite;
            }
            span.selected {
              color: #ff4b22 !important;
              animation: turn 2s linear infinite;
            }
          }
        }
        .r-progress {
          position: absolute;
          background: #f1b76a;
          border-radius: 0.04rem;
          width: calc(100% - 0.32rem);
          height: 0.04rem;
          bottom: 0.44rem;
          display: flex;
          align-items: center;
          span:first-child {
            position: absolute;
            background: #ff4b22;
            width: 0.12rem;
            height: 0.12rem;
            border-radius: 0.12rem;
            left: 0;
          }
          span:nth-child(2) {
            position: absolute;
            background: #ff4b22;
            width: 0;
            height: 0.04rem;
            border-radius: 0.04rem;
            left: 0;
          }
        }
      }
    }
  }

  /**规则弹窗 */
  .introduce {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-image: linear-gradient(180deg, #fba85d 0%, #f94a44 100%);
    border-radius: 0.1rem;
    width: 3.27rem;
    min-height: 3.66rem;
    padding: 0.08rem;
    .title {
      position: absolute;
      top: 0;
      width: 1.4rem;
      height: 0.36rem;
      background: url("~@/assets/images/spin_win/rule_title.png") no-repeat;
      background-size: 1.4rem 0.36rem;
    }
    .close {
      position: absolute;
      right: 0.22rem;
      top: 0.22rem;
      display: flex;
      width: 0.11rem;
      height: 0.11rem;
      background: url("~@/assets/images/spin_win/close.png") no-repeat;
      background-size: 0.11rem 0.11rem;
    }
    .rule_info {
      display: flex;
      width: 100%;
      min-height: 3.66rem;
      border-radius: 0.1rem;
      background: #ffffff;
      padding-bottom: 0.2rem;
      padding-top: 0.44rem;
      div:first-child {
        display: flex;
        width: 100%;
        padding: 0 0.2rem;
        height: 3.6rem;
        font-size: 0.14rem;
        color: #953700;
        overflow-y: auto;
        line-height: 0.22rem;
      }
    }
  }

  /**红包弹窗 */
  .redpack-popup {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: 5.4rem;
    overflow: hidden;

    .redpack-popup-light {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.75rem;
      height: 3.75rem;
      z-index: 73;
      img {
        width: 3.75rem;
        height: 3.75rem;
        animation: turn 4s linear infinite;
      }
    }
    .redpack-popup-content {
      display: flex;
      flex-flow: column;
      align-items: center;
      width: 2.62rem;
      height: 3.4rem;
      margin-top: 0.6rem;
      background-image: linear-gradient(
        134deg,
        #ffae0d 0%,
        #ff3341 35%,
        #ff413d 72%,
        #ff3178 100%
      );
      border-radius: 0.26rem;
      background: url("~@/assets/images/spin_win/redpackbg.png") no-repeat;
      background-size: 2.62rem 3.4rem;
      position: absolute;
      z-index: 73;

      div:first-child {
        display: flex;
        text-align: center;
        justify-content: center;
        font-size: 0.24rem;
        color: #ffe7bd;
        font-weight: 500;
        margin-top: 0.5rem;
      }

      div:nth-child(2) {
        position: relative;
        display: flex;
        align-items: center;
        color: #ffe7bd;
        height: 0.6rem;
        margin-top: 0.25rem;
        span:first-child {
          font-size: 0.72rem;
          line-height: 0.6rem;
          font-weight: bold;
          margin-right: 0.26rem;
        }
        span:nth-child(2) {
          position: absolute;
          font-size: 0.1rem;
          right: 0;
          top: 0.06rem;
          text-align: center;
        }
        span:nth-child(3) {
          position: absolute;
          text-align: center;
          font-size: 0.22rem;
          font-weight: 500;
          right: 0;
          bottom: 0;
        }
      }
    }

    .redpack-popup-close {
      position: absolute;
      display: flex;
      width: 0.3rem;
      height: 0.3rem;
      background: url("~@/assets/images/spin_win/redpack_close.png") no-repeat;
      background-size: 0.3rem 0.3rem;
      bottom: 0;
    }
  }

  /deep/ .redpack-popup-wrapper {
    top: 40% !important;
  }

  /**奖励弹窗 */
  .reward-popup {
    display: flex;
    justify-content: center;
    position: relative;
    width: 3.5rem;
    height: 3.6rem;
    overflow: hidden;

    .reward-light {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2rem;
      height: 1.9rem;
      img {
        width: 2rem;
        height: 1.9rem;
        animation: turn 3s linear infinite;
      }
    }

    .reward-popup-content {
      position: absolute;
      display: flex;
      flex-flow: column;
      align-items: center;
      width: 100%;
      top: 0.42rem;
      margin-left: -0.1rem;
      z-index: 73;
      div:first-child {
        display: flex;
        justify-content: center;
        width: 2.1rem;
        height: 1rem;
        background: url("~@/assets/images/spin_win/reward_normal.png") no-repeat;
        background-size: 2.1rem 1rem;
      }
      div.double-class {
        background: url("~@/assets/images/spin_win/reward_double.png") no-repeat;
        background-size: 2.1rem 1rem;
      }

      div:nth-child(2).double-txt {
        display: flex;
        justify-content: center;
        margin-top: 0.05rem;
        font-size: 0.14rem;
        color: #fee377;
        font-weight: bold;
        background-image: -webkit-linear-gradient(
          top,
          #fff5cd,
          #fee377
        ); // 文字渐变
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      div:nth-child(3) {
        position: relative;
        display: flex;
        justify-content: center;
        margin-top: 0.1rem;
        span {
          color: #fee377;
          font-weight: bold;
          background-image: -webkit-linear-gradient(
            top,
            #fff5cd,
            #fee377
          ); // 文字渐变
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        span:first-child {
          position: absolute;
          bottom: 0;
          left: -0.2rem;
          font-size: 0.24rem;
        }
        span:nth-child(2) {
          font-size: 0.48rem;
          height: 0.5rem;
          line-height: 0.5rem;
          margin-right: 0.12rem;
        }
        span:nth-child(3) {
          position: absolute;
          bottom: 0.04rem;
          right: -0.2rem;
          font-size: 0.16rem;
          letter-spacing: -0.46px;
        }
        span:nth-child(4) {
          position: absolute;
          top: 0.04rem;
          right: -0.46rem;
          font-size: 0.12rem;
          letter-spacing: -0.434px;
        }
      }
      div:nth-child(4) {
        margin-top: 0.02rem;
        font-size: 0.14rem;
        color: #ffffff;
      }

      div:nth-child(5) {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.18rem;
        font-size: 0.16rem;
        color: #ffffff;
        width: 1.28rem;
        height: 0.44rem;
        background: url("~@/assets/images/spin_win/reward_btn.png") no-repeat;
        background-size: 1.28rem 0.44rem;

        span:first-child {
          display: flex;
          img {
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.06rem;
          }
        }
        span:nth-child(3) {
          position: absolute;
          top: -0.12rem;
          right: 0;
          width: 0.36rem;
          height: 0.23rem;
          background: url("~@/assets/images/spin_win/high.png") no-repeat;
          background-size: 0.36rem 0.23rem;
        }
      }
      div:nth-child(6) {
        margin-top: 0.16rem;
        font-size: 0.14rem;
        letter-spacing: -0.4px;
        color: #b0a472;
      }
    }
  }

  /deep/.van-popup {
    background: transparent;
  }
  /**旋转动画 */
  @keyframes turn {
    0% {
      -webkit-transform: rotate(0deg);
    }
    25% {
      -webkit-transform: rotate(90deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    75% {
      -webkit-transform: rotate(270deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  /**上下跳动动画 */
  @keyframes jump {
    10% {
      -webkit-transform: rotate(15deg);
    }
    20% {
      -webkit-transform: rotate(-10deg);
    }
    30% {
      -webkit-transform: rotate(5deg);
    }
    40% {
      -webkit-transform: rotate(-5deg);
    }
    50%,100% {
      -webkit-transform: rotate(0deg);
    }
  }

}
</style>